// Recipes.js
import React, { useEffect, useState } from 'react';
import Layout from "../Components/Layout";
import Categories from '../Components/Categorie';
import '../Styles/recipe.css';
import ReactCardFlip from 'react-card-flip';

const Recipes = () => {
    const [recipes, setRecipes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isFlipped, setIsFlipped] = useState({});
    const [query, setQuery] = useState('');
    const [filteredRecipes, setFilteredRecipes] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');

    const handleInputChange = (event) => {
        setQuery(event.target.value);
    };

    const handleSearch = () => {
        const lowerCaseQuery = query.toLowerCase();

        const filtered = recipes.filter(recipe =>
            recipe.title.toLowerCase().includes(lowerCaseQuery) ||
            (recipe.extendedIngredients && recipe.extendedIngredients.some(ingredient =>
                ingredient.original.toLowerCase().includes(lowerCaseQuery)
            ))
        );
        setFilteredRecipes(filtered);
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleSearch();
        }
    };

    useEffect(() => {
        const fetchRecipes = async () => {
            try {
                let url = `https://api.spoonacular.com/recipes/random?number=40&apiKey=2cff887db834416098ee9a16a84852cf`;
                if (selectedCategory) {
                    url = `https://api.spoonacular.com/recipes/complexSearch?number=40&cuisine=${selectedCategory}&apiKey=2cff887db834416098ee9a16a84852cf`;
                }
                const response = await fetch(url);
                const data = await response.json();
                if (data.recipes) {
                    setRecipes(data.recipes);
                    setFilteredRecipes(data.recipes);
                } else if (data.results) { // complexSearch response format
                    setRecipes(data.results);
                    setFilteredRecipes(data.results);
                } else {
                    console.error('Unexpected response format', data);
                }
                setLoading(false);
            } catch (error) {
                console.error("Error fetching recipes:", error);
                setLoading(false);
            }
        };

        fetchRecipes();
    }, [selectedCategory]);

    const handleCategorySelect = (category) => {
        setSelectedCategory(category);
    };

    const handleFlip = (id) => {
        setIsFlipped(prevState => {
            const newState = Object.keys(prevState).reduce((state, key) => {
                state[key] = false;
                return state;
            }, {});
            newState[id] = !prevState[id];
            return newState;
        });
    };

    if (loading) {
        return <p>Loading...</p>;
    }

    return (
        <Layout>

            <div className="recipes-container">
                <h1 className="recipes-title">Gerechten</h1>
                <p className="recipes-slogan">Ontdek heerlijke recepten om van te genieten</p>
                <div className='search-page-wrapper'>
                    <div className='contact-form-container'>
                        <input
                            type='search'
                            placeholder='Zoek naar Gerechten of Ingrediënten'
                            id='search'
                            value={query}
                            onChange={handleInputChange}
                            onKeyPress={handleKeyPress}
                        />
                        <button className='secondary-button' onClick={handleSearch}>
                            Zoek
                        </button>
                    </div>
                    <Categories onSelectCategory={handleCategorySelect} />
                </div>
                <div className="recipes-list">
                    {filteredRecipes.length > 0 ? (
                        filteredRecipes.map(recipe => (
                            <ReactCardFlip key={recipe.id} isFlipped={isFlipped[recipe.id]} flipDirection="horizontal">
                                <div className="recipe-card" onClick={() => handleFlip(recipe.id)}>
                                    <div className='info-boxes-img-container'>
                                        <img src={recipe.image} alt={recipe.title} />
                                    </div>
                                    <h2>{recipe.title}</h2>
                                </div>
                                <div className="recipe-card" onClick={() => handleFlip(recipe.id)}>
                                    <div className="recipe-card-content">
                                        <h2>{recipe.title}</h2>
                                        <h3>Bereidingswijze:</h3>
                                        <p dangerouslySetInnerHTML={{ __html: recipe.instructions }}></p>
                                        <h3>Ingrediënten:</h3>
                                        <ul>
                                            {recipe.extendedIngredients && recipe.extendedIngredients.map(ingredient => (
                                                <li key={ingredient.id}>{ingredient.original}</li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </ReactCardFlip>
                        ))
                    ) : (
                        <p className={"NoRecipes"}>No Recipes Found</p>
                    )}
                </div>
            </div>
        </Layout>
    );
};

export default Recipes;
